import { Label, Radio } from "flowbite-react";
import { MdError } from "react-icons/md";

export function RadioInput({ legend, options, id, horizontal, name, value, onChange, onBlur, error, required = false }) {
    return (
        <div>
            <fieldset className={`flex ${horizontal ? "flex-row" : "flex-col"} gap-2`}>
                {legend && <legend className={"text-sm font-medium  text-textLight"}>{legend}{required ? <span className={"text-red-600"}>*</span> : ""}</legend>}
                {options.map((item) => (
                    <div key={item.id} className={`flex items-center gap-2 ${item?.disabled ? "" : "cursor-pointer"}`}>
                        <Radio
                            id={item.id + id}
                            name={name}
                            value={item.value}
                            checked={value == item.value}
                            disabled={item.disabled}
                            onChange={onChange}
                            onBlur={onBlur}
                            className={`text-primary-800 ${item?.disabled ? "" : "cursor-pointer"}`}
                        />
                        <Label className="" htmlFor={item.id} disabled={item.disabled}>
                            {item.name}
                        </Label>
                    </div>
                ))}
            </fieldset>
            {error ?
                <span className="flex items-center gap-1 text-sm text-error-600">
                    <MdError />
                    <p>{error}</p>
                </span>
                :
                ""
            }
        </div>
    );
}
